module.exports = __webpack_public_path__ + "fonts/slick.a4e97f5.eot";